// extracted by mini-css-extract-plugin
export default {"box":"intro_box__YbRI1","text":"intro_text__3iroz","textBackground":"intro_textBackground__hYv2M","textBackgroundsm":"intro_textBackgroundsm__svsGz"};